import { useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { routesHandler as routes } from 'Checkout/Routes/routesHandler'
import { detailsToggleValidation } from 'Checkout/Redux/Actions/Details'
import { searchToggleDiscardAlert, searchToggleModifyNotSaved } from 'Checkout/Redux/Actions/Search'
import useRouter from 'Checkout/Hooks/useRouter'
import ProgressNav from 'Shared/ProgressNav/ProgressNav'
import DiscardChanges from 'Checkout/Components/Shared/DiscardChanges/DiscardChanges'

const WrapperProgressNav = ({ progressNavClass }) => {
  const dispatch = useDispatch()
  const router = useRouter()
  const [routeToGo, setRouteToGo] = useState('')
  const isDetailError = useSelector(state => state.details.isError)
  const { dayUse, isDiscardAlertOpen } = useSelector(state => state.search)
  const { isGroupBookingAvailable } = useSelector(state => state.campground)
  const hideSite = useSelector(state => {
    const sitesAllowed = !state.campground.siteLockFee?.amount && state.campground.isAutoAssign
    return sitesAllowed || state.campground.isRequest || dayUse
  })
  const isEditingReservation = useSelector(state => !!state.cart.editingReservationId)
  const newRateNeeded = useSelector(state => state.search.newRateNeeded)
  const newSiteNeeded = useSelector(state => state.search.newSiteNeeded)
  const steps = useMemo(() => {
    const baseSteps = [
      { index: 1, name: routes.search.name, routes: [routes.search.key] },
      { index: hideSite ? 0 : 2, name: routes.sites.name, routes: [routes.sites.key] },
      { index: hideSite ? 2 : 3, name: routes.details.name, routes: [routes.details.key] },
    ]

    if (isGroupBookingAvailable)
      baseSteps.push({ index: hideSite ? 3 : 4, name: routes.cart.name, routes: [routes.cart.key], icon: 'check' })

    return baseSteps.filter(step => step.index !== 0)
  }, [hideSite])
  const currentRoute = router.history.to?.key
  const isRatePage = currentRoute === routes.search.key
  const validateSiteWithRoute = nextRoute => {
    const nextStep = steps.find(step => step.routes.includes(nextRoute))

    return (!hideSite && newSiteNeeded && nextStep.index > 2) || (nextStep.index === 4)
  }

  const goToRoute = route => {
    setRouteToGo(route)
    if (newRateNeeded || validateSiteWithRoute(route)) return dispatch(searchToggleDiscardAlert())
    if (isEditingReservation && route === routes.cart.key && currentRoute === routes.details.key) {
      if (isDetailError) return dispatch(searchToggleModifyNotSaved())

      return dispatch(detailsToggleValidation())
    }

    router.go(routes[route].path)
  }

  const toggle = () => dispatch(searchToggleDiscardAlert())

  return (
    <>
      <ProgressNav currentRoute={currentRoute} goToRoute={goToRoute} hideStepNumber
                   isEditing={isEditingReservation} progressNavClass={progressNavClass} steps={steps} />

      <DiscardChanges isRatePage={isRatePage} isOpen={isDiscardAlertOpen} routeToGo={routeToGo}
                      toggle={toggle} />
    </>
  )
}

export default WrapperProgressNav
